import { Box } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { HiringStageBox } from 'modules/ats/components/HiringStages/HiringStageBox'
import { UNASSIGNED_STAGE, isHiringStageEditable } from 'modules/ats/lib/utils/hiringStages'
import { HiringStageWithApplicationPhases } from 'modules/ats/pages/JobPostingSettings/HiringPipeline/utils'

import { EditableHiringStage } from './EditableHiringStage'
import { UnassignedHiringPhases } from './UnassignedHiringPhases'

interface Props {
  onClose: () => void
  stages: HiringStageWithApplicationPhases[]
  jobId: number
}

export const EditPipelineSidepanel = ({ onClose, stages, jobId }: Props) => {
  return (
    <Sidepanel
      width="wide"
      title={i18n.t('ats.job_posting_settings.hiring_pipeline.customize_sidepanel_title')}
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
      open
    >
      <Box gap="s16">
        {stages.map((stage) => (
          <Box key={`stage-item-${stage.id}`} gap="s16">
            {stage.name === UNASSIGNED_STAGE ? (
              <UnassignedHiringPhases unassignedPhases={stage.applicationPhases} />
            ) : isHiringStageEditable(stage.name) ? (
              <EditableHiringStage jobId={jobId} stage={stage} />
            ) : (
              <HiringStageBox stageName={stage.name} stageLabel={stage.label} />
            )}
          </Box>
        ))}
      </Box>
    </Sidepanel>
  )
}
